/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PendingDocSharesBox_PendingDocShareFragment = { __typename: 'PendingDocShare', id: string, docTitle: string, sharingSystemOrganisationId: string, sharingSystemOrganisationTitle: string, createdAt: any, docType: Types.DocType, netTotal?: number | null, projectLocation?: { __typename: 'PendingDocShareProjectLocation', postalCode: string, city: string } | null };

export type PendingDocSharesBox_PendingDocSharesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PendingDocSharesBox_PendingDocSharesQuery = { pendingDocShares: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PendingDocSharesResult', pendingDocShares: Array<{ __typename: 'PendingDocShare', id: string, docTitle: string, sharingSystemOrganisationId: string, sharingSystemOrganisationTitle: string, createdAt: any, docType: Types.DocType, netTotal?: number | null, projectLocation?: { __typename: 'PendingDocShareProjectLocation', postalCode: string, city: string } | null }> } };

export type PendingDocSharesBox_PendingDocShareClientActorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PendingDocSharesBox_PendingDocShareClientActorQuery = { pendingDocShare: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PendingDocShareResult', pendingDocShare: { __typename: 'PendingDocShare', id: string, clientActor?: { __typename: 'PendingDocShareClientActor', type: Types.DocActorType, companyOrIndividual: Types.DocActorCompanyOrIndividual, companyName?: string | null, firstname?: string | null, familyname?: string | null, salutation?: Types.Salutation | null, email?: string | null, matchedCrmCompanyId?: string | null, matchedCrmCompanyTitle?: string | null } | null } } };

export const PendingDocSharesBox_PendingDocShareFragmentDoc = gql`
    fragment PendingDocSharesBox_PendingDocShare on PendingDocShare {
  id
  docTitle
  sharingSystemOrganisationId
  sharingSystemOrganisationTitle
  createdAt
  docType
  netTotal
  projectLocation {
    postalCode
    city
  }
}
    `;
export const PendingDocSharesBox_PendingDocSharesDocument = gql`
    query PendingDocSharesBox_PendingDocShares {
  pendingDocShares {
    __typename
    ... on PendingDocSharesResult {
      pendingDocShares {
        ...PendingDocSharesBox_PendingDocShare
      }
    }
  }
}
    ${PendingDocSharesBox_PendingDocShareFragmentDoc}`;

/**
 * __usePendingDocSharesBox_PendingDocSharesQuery__
 *
 * To run a query within a React component, call `usePendingDocSharesBox_PendingDocSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingDocSharesBox_PendingDocSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingDocSharesBox_PendingDocSharesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingDocSharesBox_PendingDocSharesQuery(baseOptions?: Apollo.QueryHookOptions<PendingDocSharesBox_PendingDocSharesQuery, PendingDocSharesBox_PendingDocSharesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingDocSharesBox_PendingDocSharesQuery, PendingDocSharesBox_PendingDocSharesQueryVariables>(PendingDocSharesBox_PendingDocSharesDocument, options);
      }
export function usePendingDocSharesBox_PendingDocSharesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingDocSharesBox_PendingDocSharesQuery, PendingDocSharesBox_PendingDocSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingDocSharesBox_PendingDocSharesQuery, PendingDocSharesBox_PendingDocSharesQueryVariables>(PendingDocSharesBox_PendingDocSharesDocument, options);
        }
export function usePendingDocSharesBox_PendingDocSharesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingDocSharesBox_PendingDocSharesQuery, PendingDocSharesBox_PendingDocSharesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingDocSharesBox_PendingDocSharesQuery, PendingDocSharesBox_PendingDocSharesQueryVariables>(PendingDocSharesBox_PendingDocSharesDocument, options);
        }
export type PendingDocSharesBox_PendingDocSharesQueryHookResult = ReturnType<typeof usePendingDocSharesBox_PendingDocSharesQuery>;
export type PendingDocSharesBox_PendingDocSharesLazyQueryHookResult = ReturnType<typeof usePendingDocSharesBox_PendingDocSharesLazyQuery>;
export type PendingDocSharesBox_PendingDocSharesSuspenseQueryHookResult = ReturnType<typeof usePendingDocSharesBox_PendingDocSharesSuspenseQuery>;
export type PendingDocSharesBox_PendingDocSharesQueryResult = Apollo.QueryResult<PendingDocSharesBox_PendingDocSharesQuery, PendingDocSharesBox_PendingDocSharesQueryVariables>;
export const PendingDocSharesBox_PendingDocShareClientActorDocument = gql`
    query PendingDocSharesBox_PendingDocShareClientActor($id: ID!) {
  pendingDocShare(id: $id) {
    __typename
    ... on PendingDocShareResult {
      pendingDocShare {
        id
        clientActor {
          type
          companyOrIndividual
          companyName
          firstname
          familyname
          salutation
          email
          matchedCrmCompanyId
          matchedCrmCompanyTitle
        }
      }
    }
  }
}
    `;

/**
 * __usePendingDocSharesBox_PendingDocShareClientActorQuery__
 *
 * To run a query within a React component, call `usePendingDocSharesBox_PendingDocShareClientActorQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingDocSharesBox_PendingDocShareClientActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingDocSharesBox_PendingDocShareClientActorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePendingDocSharesBox_PendingDocShareClientActorQuery(baseOptions: Apollo.QueryHookOptions<PendingDocSharesBox_PendingDocShareClientActorQuery, PendingDocSharesBox_PendingDocShareClientActorQueryVariables> & ({ variables: PendingDocSharesBox_PendingDocShareClientActorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingDocSharesBox_PendingDocShareClientActorQuery, PendingDocSharesBox_PendingDocShareClientActorQueryVariables>(PendingDocSharesBox_PendingDocShareClientActorDocument, options);
      }
export function usePendingDocSharesBox_PendingDocShareClientActorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingDocSharesBox_PendingDocShareClientActorQuery, PendingDocSharesBox_PendingDocShareClientActorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingDocSharesBox_PendingDocShareClientActorQuery, PendingDocSharesBox_PendingDocShareClientActorQueryVariables>(PendingDocSharesBox_PendingDocShareClientActorDocument, options);
        }
export function usePendingDocSharesBox_PendingDocShareClientActorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingDocSharesBox_PendingDocShareClientActorQuery, PendingDocSharesBox_PendingDocShareClientActorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingDocSharesBox_PendingDocShareClientActorQuery, PendingDocSharesBox_PendingDocShareClientActorQueryVariables>(PendingDocSharesBox_PendingDocShareClientActorDocument, options);
        }
export type PendingDocSharesBox_PendingDocShareClientActorQueryHookResult = ReturnType<typeof usePendingDocSharesBox_PendingDocShareClientActorQuery>;
export type PendingDocSharesBox_PendingDocShareClientActorLazyQueryHookResult = ReturnType<typeof usePendingDocSharesBox_PendingDocShareClientActorLazyQuery>;
export type PendingDocSharesBox_PendingDocShareClientActorSuspenseQueryHookResult = ReturnType<typeof usePendingDocSharesBox_PendingDocShareClientActorSuspenseQuery>;
export type PendingDocSharesBox_PendingDocShareClientActorQueryResult = Apollo.QueryResult<PendingDocSharesBox_PendingDocShareClientActorQuery, PendingDocSharesBox_PendingDocShareClientActorQueryVariables>;